import src from "IMAGE";
export default { src, width: 177, height: 36, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ABMYHzAQGB8vBRQaKQYTGSgHFBkoERATIjUPDScvDQsiABsZHzEWGiAyCBsjNwkhLEcJGiEzIhshPFUXFj9ZGBU/5hIH8U6ePGMAAAAASUVORK5CYII="};
